import React from 'react';

import styles from './HeaderSection.css';

interface IHeaderSectionProps {
  breadcrumbs: React.ReactNode;
  mapBanner: React.ReactNode;
  summary: React.ReactNode;
}

export function HeaderSection({ breadcrumbs, mapBanner, summary }: IHeaderSectionProps) {
  return (
    <div className={styles['section']}>
      <div className={styles['left-column']}>
        <div className={styles['breadcrumbs']}>{breadcrumbs}</div>
        <div className={styles['summary']}>{summary}</div>
      </div>
      <div className={styles['right-column']}>{mapBanner}</div>
    </div>
  );
}
